import { c as _c } from "react/compiler-runtime";
import { ProgressStepper } from "@justhome/react-ui";
type ProgressBarHeaderProps = {
  currentStepNumber: number;
  numberOfSteps: number;
};
const ProgressBarHeader = t0 => {
  const $ = _c(6);
  const {
    currentStepNumber,
    numberOfSteps
  } = t0;
  const showStepper = typeof numberOfSteps === "number";
  let t1;
  if ($[0] !== currentStepNumber || $[1] !== numberOfSteps || $[2] !== showStepper) {
    t1 = showStepper && <ProgressStepper currentStep={currentStepNumber} steps={numberOfSteps} />;
    $[0] = currentStepNumber;
    $[1] = numberOfSteps;
    $[2] = showStepper;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t1) {
    t2 = <>{t1}</>;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};
export default ProgressBarHeader;